import { Component, OnInit } from '@angular/core';
import {GeneralExerciseComponent} from '../../General/g-exercise.component';
import {ActivatedRoute} from '@angular/router';
import {TopicService} from '../topic.service';
import {MessageService} from '../../shared/message.service';

@Component({
  selector: 'app-generate-encoding-build-message',
  templateUrl: './generate-encoding-build-message.component.html',
  styleUrls: ['./generate-encoding-build-message.component.css']
})
export class GenerateEncodingBuildMessageComponent extends GeneralExerciseComponent implements OnInit {

  constructor(activatedRoute: ActivatedRoute, topicService: TopicService, messageService: MessageService) {
    super(activatedRoute, topicService, messageService);
    this.printable = true;
  }

  ngOnInit() {
  }

  checkSolution() {
  }

  computeState() {
  }

  generateNextExercise() {
  }

  initValues() {
  }

  setTypeSpecificsFromConfiguration() {
  }

  setTypeSpecificsFromState() {
  }

}
